<div #backdrop class="drawer-backdrop"></div>
<ng-content select="sim-drawer" />
<ng-content select="sim-drawer-content" />
